// FILE: assets/bold-sc-qb-table.js
(function() {
  if (customElements.get('bold-qb-table')) return;

  class BoldQbTable extends HTMLElement {
    constructor() {
      super();
      this.facade = null;
      this.renderedVariant = null;
      this._booted = false;
      this._signalSent = false;
      this._skipFirstBreak = false;
      this._domTierIndexes = [];
      this._movedTable = false;

      this._lastHighlightDomIndex = null;
      this._lastBreakStatus = 'unknown';
      this._absoluteHydrationCheckScheduled = false;

      // Listen for facade price updates
      this._update = this._update.bind(this);
      this._moveTable = this._moveTable.bind(this);
      this.EVENTS = {
        PRICE_RECALCULATED: 'hub:price:recalculated',
        QUANTITY_PICKER_LOADED: 'hub:qty:picker_loaded',
        QUANTITY_BREAKS_LOADED: 'hub:pre:breaks_loaded',
      };
    }

    connectedCallback() {
        if (this._booted) return;

        const adapter = document.querySelector('bold-sc-adapter');
        this.facade = adapter ? adapter.facade : null;

        if (adapter && adapter.getAttribute('options') === 'ready') {
            this._init();
        } else {
            document.addEventListener("hub:options:ready", () => {
                const tryInit = (attempt = 0) => {
                    const a = document.querySelector('bold-sc-adapter');
                    this.facade = a ? a.facade : null;
                    if (this.facade || attempt >= 5) {
                        this._init();
                    } else {
                        setTimeout(() => tryInit(attempt + 1), 100);
                    }
                };
                tryInit();
            }, { once: true });
        }
    }

    disconnectedCallback() {
      this._booted = false;
      this._domTierIndexes = [];
      this._skipFirstBreak = false;
      document.removeEventListener(this.EVENTS.QUANTITY_PICKER_LOADED, this._moveTable);
      document.removeEventListener(this.EVENTS.PRICE_RECALCULATED, this._update);
      document.removeEventListener(this.EVENTS.QUANTITY_BREAKS_LOADED, this._update);
    }

    _init() {
      if (this._booted || !this.facade) return;
      this._booted = true;

      document.addEventListener(this.EVENTS.QUANTITY_PICKER_LOADED, this._moveTable);
      document.addEventListener(this.EVENTS.PRICE_RECALCULATED, this._update);
      document.addEventListener(this.EVENTS.QUANTITY_BREAKS_LOADED, this._update);

       // Optional but recommended: an immediate attempt to sync current state
       /*
      if (this.facade.actions && typeof this.facade.actions.recalculateAll === 'function') {
        try {
          this.facade.actions.recalculateAll(true);
        } catch (err) {
          console.warn('[Bold Table] recalculateAll on init failed', err);
        }
      }
        */
      this._update();

      // NEW: absolute fallback check a few seconds after boot
      if (!this._absoluteHydrationCheckScheduled) {
        this._absoluteHydrationCheckScheduled = true;

        setTimeout(() => {
          // Component might have been removed or facade changed
          if (!this.facade) return;

          try {
            if (this.facade.actions && typeof this.facade.actions.recalculateAll === 'function') {
              this.facade.actions.recalculateAll(true);
              console.log('recalc from timeout');
            }
            this._update();
          } catch (err) {
            console.warn('[Bold Table] absolute hydration check failed', err);
          }
        }, 500); // adjust delay if you want
      }
    }

    _moveTable() {
        if (this._movedTable) return;

        const newTableComponent = document.querySelector("bold-qb-table");
        const legacyWrapper = document.querySelector(".money-template, .bold_qb_grid");
        const legacyTable = document.querySelector("table.shappify_qb_grid");

        let elementToMove = newTableComponent || legacyWrapper || legacyTable;
        if (!elementToMove) return;

        const greyBox = document.querySelector('.quantity-slider-group');
       // console.log(newTableComponent, greyBox);
        /*
        if (this.querySelector(".matrix-grid-container")) {
            greyBox = this.querySelector(".quantity-slider-group");
        } else {
            greyBox = this.closest(".quantity-slider-group");
        }
        */
        if (!greyBox) return;

        let nodeToInsert;

        if (newTableComponent) {
          // Our modern component already renders its own card wrapper
          nodeToInsert = newTableComponent;
        } else {
          // Legacy table → wrap it in the card container
          const tableCard = document.createElement("div");
          tableCard.className = "bold-table-card bold-price-table-container";
          tableCard.appendChild(elementToMove);
          nodeToInsert = tableCard;
        }
        

        if (greyBox.querySelector(".matrix-grid-container")) {
            const existingWrapper = greyBox.querySelector(".bold-integrated-wrapper");

            if (existingWrapper && existingWrapper.contains(nodeToInsert)) return;

            const orphans = greyBox.querySelectorAll(".bold-integrated-wrapper");
            orphans.forEach((el) => el.remove());
            greyBox.appendChild(nodeToInsert);
        } else {
            nodeToInsert.style.width = "100%";
            nodeToInsert.style.marginTop = "0";
            nodeToInsert.style.marginBottom = "20px";
            nodeToInsert.style.flexBasis = "100%";
            greyBox.insertBefore(nodeToInsert, greyBox.firstChild);
        }

        this._movedTable = true;
        this._update();

        // If a letter-generator is present, move the quantity picker
        // (which now contains this table) before the collapsible options section.
        if (document.querySelector('letter-generator')) {
            this._moveBeforeCollapsible();
        }
    }

    _moveBeforeCollapsible() {
        const picker = document.querySelector('bold-quantity-picker');
        if (!picker) return;

        // Move the product form quantity wrapper which contains the bold-quantity-block.
        // This keeps the styling context intact while relocating the entire section.
        const block = picker.closest('.product-form__input.product-form__quantity')
            || picker.closest('.bold-quantity-block')
            || picker;

        const doMove = () => {
            const collapsible = document.querySelector('.bold-collapsible');
            if (!collapsible) return false;
            collapsible.parentElement.insertBefore(block, collapsible.nextSibling);
            return true;
        };

        if (!doMove()) {
            const obs = new MutationObserver(() => {
                if (doMove()) obs.disconnect();
            });
            obs.observe(document.body, { childList: true, subtree: true });
        }
    }


    
    _update() {
      if (!this.facade) return;

      const snapshot = this.facade.state.getSnapshot
        ? this.facade.state.getSnapshot()
        : null;
      const currentVariant = snapshot ? snapshot.variant : null;

      // NEW: ask the facade about break status
      let breakStatus = 'unknown';
      if (this.facade.state && typeof this.facade.state.getBreakStatus === 'function') {
        breakStatus = this.facade.state.getBreakStatus(currentVariant);
      }

      // If facade hasn't decided yet, keep table hidden
      if (breakStatus === 'unknown') {
        this._lastBreakStatus = breakStatus;
        this.innerHTML = '';
        this.style.display = 'none';
        this.renderedVariant = null;
        return;
      }

      if (breakStatus === 'noBreaks') {
        this._lastBreakStatus = breakStatus;
        this.innerHTML = '';
        this.style.display = 'none';
        this.renderedVariant = currentVariant;
        return;
      }

      // At this point breakStatus === 'hasBreaks' (or unknown API, fallback)
      const tiers = this.facade.state.getTiers();
      if (!tiers || tiers.length === 0) {
        this.innerHTML = '';
        this.style.display = 'none';
        return;
      }

      this.style.display = 'block';


      // Decide if we need to re-render the DOM:
      //
      //  - always re-render on variant change
      //  - ALSO re-render when we just transitioned into 'hasBreaks'
      //    (e.g. previously 'noBreaks' but PRE eventually provided qty_breaks)
      const shouldRerender =
        this.renderedVariant !== currentVariant ||
        this._lastBreakStatus !== 'hasBreaks';

      this._lastBreakStatus = 'hasBreaks';

      if (shouldRerender) {
        this._renderTable(tiers);
        this.renderedVariant = currentVariant;
      }

      const activeIndex = this.facade.state.getActiveIndex();
      this._applyHighlighting(activeIndex);
      this._updateNudgeText();
    }

    _renderTable(tiers) {
      if (!Array.isArray(tiers) || tiers.length === 0 || !this.facade) {
        this.innerHTML = '';
        return;
      }

      // 1. Read minimum quantity from product (hub data)
      let productMinQty = 1;
      if (this.facade.state && typeof this.facade.state.getProduct === 'function') {
        const product = this.facade.state.getProduct();
        if (product && product.minimum_quantity != null) {
          const parsed = parseInt(product.minimum_quantity, 10);
          if (!Number.isNaN(parsed) && parsed > 0) {
            productMinQty = parsed;
          }
        }
      }

      // 2. Detect "duplicate price" first break (same price tier 0 & tier 1)
      let skipFirstBreak = false;
      if (
        tiers.length > 1 &&
        typeof tiers[0].price === 'number' &&
        typeof tiers[1].price === 'number' &&
        tiers[0].price === tiers[1].price
      ) {
        skipFirstBreak = true;
      }
      this._skipFirstBreak = skipFirstBreak;

      const domTierIndexes = [];
      const qtyCells = [];
      const priceCells = [];

      const startIndex = skipFirstBreak ? 1 : 0;
      const firstVisibleTier = tiers[startIndex];

      if (!firstVisibleTier) {
        this.innerHTML = '';
        this._domTierIndexes = [];
        return;
      }

      // 3. Effective minimum label for the first visible column
      let effectiveMinQty = firstVisibleTier.min;
      if (productMinQty > effectiveMinQty) {
        effectiveMinQty = productMinQty;
      }

      const formatMoney = (cents) => {
        if (this.facade.tools && typeof this.facade.tools.formatMoney === 'function') {
          return this.facade.tools.formatMoney(cents);
        }
        return cents;
      };

      for (let i = startIndex; i < tiers.length; i++) {
        const tier = tiers[i];
        domTierIndexes.push(i);

        const qtyLabel = i === startIndex ? effectiveMinQty : tier.min;
        qtyCells.push(`<td>${qtyLabel}</td>`);

        const priceStr = formatMoney(tier.price);
        priceCells.push(`<td>${priceStr}</td>`);
      }

      this._domTierIndexes = domTierIndexes;

      const labelQty = `<abbr title="Minimum Quantity">Min Qty</abbr>`;
      const labelPrice = 'Item Price';

      const visibleTierCount = this._domTierIndexes ? this._domTierIndexes.length : 0;
      let containerClass = 'bold-table-card bold-price-table-container bold-table-entering ';
      if (visibleTierCount >= 6) containerClass = containerClass += 'bold-qb-many-tiers'
      // Includes Wrapper DIV for Card Styling
      this.innerHTML = `
        <div class="${containerClass}">
          <div class="bold-integrated-wrapper bold-load-animation">
            <div class="bold-qb-header-bar">
                <div class="bold-qb-total-wrapper">
                    <span>Total Qty: <strong id="header-qty-counter" style="color:rgb(var(--color-brand-primary));">${this.facade.state.getQuantity()}</strong></span>
                </div>
                <div class="bold-qb-help-text">
                    <span></span>
                </div>
            </div>
          </div>
          <div class="bold-price-scroll">
            <table class="js-grid" data-table-version="v3">
              <tbody>
                <tr>
                  <th scope="row">${labelQty}</th>
                  ${qtyCells.join('')}
                </tr>
                <tr>
                  <th scope="row">${labelPrice}</th>
                  ${priceCells.join('')}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      `;

      // Dispatch event ONCE so Quantity Picker knows to move this element
      if (!this._signalSent) {
        this._signalSent = true;
        this.dispatchEvent(new Event('bold:qb:loaded', { bubbles: true }));
      }
    }

    _updateNudgeText() {
      if (!this.facade) return;
      const total = this.facade.state.getQuantity();

      let counter = document.getElementById("header-qty-counter");
      if (!counter && this.querySelector(".bold-integrated-wrapper")) {
          const headerBar = this.querySelector(".bold-qb-header-bar");
          if (headerBar) {
              counter = headerBar.querySelector("strong");
              if (counter) counter.id = "header-qty-counter";
          }
      }

      if (counter) counter.textContent = total;

      const nudgeText = this.querySelector('.bold-qb-help-text');
      if (!nudgeText) return;

      const nextTierGap = this.facade.state.getNextTierGap();
      const currentPrice = this.facade.state.getCurrentPrice();
      const nextTierPrice = this.facade.state.nextTierPrice();
      const matrix = this.facade.state.getMatrix();
      const hasSize = !!matrix && Object.keys(matrix).length > 0;
      const hasTable = this.facade.state.getTiers().length > 0;

      let newState, newHTML, newColor, newWeight;

      if (nextTierGap > 0 && nextTierGap <= 6 && total > 0) {
        const saving = this.facade.tools.formatMoney(currentPrice - nextTierPrice);
        newState = 'urgency';
        newHTML = `Add <strong>${nextTierGap}</strong> more to save <strong>${saving}/ea</strong>`;
        newColor = "#d32f2f";
        newWeight = "bold";
      } else {
        newState = 'default';
        newHTML = !hasSize && hasTable
          ? "Add more to reach the next price break"
          : "Mix sizes to reach the next price break";
        newColor = "";
        newWeight = "normal";
      }

      // Only animate when state or content changes
      const prevState = nudgeText.dataset.nudgeState || '';
      const prevHTML = nudgeText.innerHTML;
      const changed = newState !== prevState || newHTML !== prevHTML;

      nudgeText.innerHTML = newHTML;
      nudgeText.style.color = newColor;
      nudgeText.style.fontWeight = newWeight;
      nudgeText.dataset.nudgeState = newState;

      if (changed) {
        nudgeText.classList.remove('bold-nudge-animate');
        // Force reflow to restart animation
        void nudgeText.offsetWidth;
        nudgeText.classList.add('bold-nudge-animate');
      }
    }

      _scrollActiveTierIntoView(domColIndex) {
        // Find the horizontal scroll container used for the table
        let container =
          this.querySelector('.bold-price-scroll') ||  // if you added this wrapper
          this.querySelector('.bold-price-table-container') ||
          this.parentElement;

        if (!container) return;

        // If there's nothing to scroll, bail
        if (container.scrollWidth <= container.clientWidth) return;

        const table = this.querySelector('table');
        if (!table) return;

        const firstRow = table.querySelector('tr');
        if (!firstRow || !firstRow.children[domColIndex]) return;

        const cell = firstRow.children[domColIndex];

        const containerRect = container.getBoundingClientRect();
        const cellRect = cell.getBoundingClientRect();

        // Position so the active tier is roughly centered in the visible area
        const offsetLeft = cellRect.left - containerRect.left;
        const targetScrollLeft =
          container.scrollLeft + offsetLeft - (containerRect.width / 2 - cellRect.width / 2);

        container.scrollTo({
          left: Math.max(0, targetScrollLeft),
          behavior: 'smooth'
        });
      }


    _applyHighlighting(activeIndex) {
        const table = this.querySelector('table');
        if (!table) return;

        // 1. Clear existing highlights
        const allCells = table.querySelectorAll('td, th');
        allCells.forEach((c) => c.classList.remove('color-scheme-9'));

        // Normalize incoming index
        let effectiveIndex = Number.isFinite(activeIndex) ? activeIndex : -1;

        // 2. Fallback: if facade didn't report a valid tier index,
        //    but we have a positive quantity, assume we're in the last tier.
        if (
            (effectiveIndex < 0 || !Number.isFinite(effectiveIndex)) &&
            this.facade &&
            this.facade.state &&
            Array.isArray(this._domTierIndexes) &&
            this._domTierIndexes.length > 0
        ) {
            let qty = 0;
            try {
            if (typeof this.facade.state.getQuantity === 'function') {
                qty = this.facade.state.getQuantity();
            } else if (typeof this.facade.state.getSnapshot === 'function') {
                const snap = this.facade.state.getSnapshot();
                qty = snap && typeof snap.quantity === 'number' ? snap.quantity : 0;
            }
            } catch (err) {
            // soft-fail: keep qty = 0
            }

            if (qty > 0) {
            // last rendered tier index from the underlying tiers array
            effectiveIndex = this._domTierIndexes[this._domTierIndexes.length - 1];
            }
        }

        // Still nothing sane to highlight
        if (effectiveIndex < 0) return;

        let targetIndex = null;

        // 3. Prefer mapping based on the tiers we actually rendered
        if (Array.isArray(this._domTierIndexes) && this._domTierIndexes.length > 0) {
            let lookupIndex = effectiveIndex;

            // Special case: when we skipped the first break, map tier 0 → tier 1
            if (this._skipFirstBreak && lookupIndex === 0 && this._domTierIndexes.includes(1)) {
            lookupIndex = 1;
            }

            const domIndex = this._domTierIndexes.indexOf(lookupIndex);
            if (domIndex !== -1) {
            // +1 to account for the leading <th> in each row
            targetIndex = domIndex + 1;
            }
        }

        // 4. Fallback to legacy behavior if we have no mapping
        if (targetIndex === null) {
            targetIndex = effectiveIndex + 1;
        }

        // 5. Apply new highlight if valid
        const rows = table.querySelectorAll('tr');
        rows.forEach((row) => {
            if (row.children[targetIndex]) {
            row.children[targetIndex].classList.add('color-scheme-9');
            }
        });

        // 6. Auto-scroll the active tier into view when it changes
        if (this._lastHighlightDomIndex !== targetIndex) {
          this._lastHighlightDomIndex = targetIndex;
          this._scrollActiveTierIntoView(targetIndex);
        }
    }

  }

  customElements.define('bold-qb-table', BoldQbTable);

    // Auto-Mount Logic (kept the same)
    /*
  document.addEventListener("hub:options:ready", () => {
    if (document.querySelector('bold-qb-table')) return;

    const anchor =
      document.querySelector('.shappify-qty-msg, .qb_grid, .bold_qb_grid') ||
      document.querySelector('bold-price-display');

    if (anchor && anchor.parentNode) {
      console.log('[Bold Table] Auto-mounting component');
      const newTable = document.createElement('bold-qb-table');
      anchor.parentNode.insertBefore(newTable, anchor);
    }
  }, { once: true });
  */
})();